<template>
  <div>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-bar-chart"></i> {{ $t('dashboard.exit.title') }}

        <div class="float-right" >
          <a href="#filter" name="filter" v-on:click="expandOrCollapseFilter">
              <span class="fa fa-expand fa-lg" v-if="!filterVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="filterVisible"></span>
          </a>
        </div>
      </div>
      <div class="card-body" v-if="filterVisible">
        
        <div class="row">

          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('address.form.region') }}</label>
            <multiselect v-model="filter.region" track-by="item1" label="item2"
              :options="regions" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('address.form.region')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-6">
            <label>{{ $t('project.company.form.sectorOfActivity') }}</label>
            <multiselect v-model="filter.sector" track-by="item1" label="item2"
              :options="sectors" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.company.form.sectorOfActivity')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-6">
            <label>{{ $t('project.form.status') }}</label>
            <multiselect v-model="filter.companyStatus" track-by="item1" label="item2"
              :options="companyStatuses" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.form.status')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

         <div class="form-group col-md-6">
            <label>{{ $t('project.exit.form.person.reason') }}</label>
            <multiselect v-model="filter.reason" track-by="item1" label="item2"
              :options="reasons" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.exit.form.person.reason')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <!--div class="form-group col-md-1"> 
            <label for="memberSince">{{ $t('dashboard.project.form.dateOfInvestissementFrom') }}</label>
            <moment-date-picker v-model="filter.dateOfInvestissementFrom" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-1">
            <label for="memberSince">{{ $t('dashboard.project.form.dateOfInvestissementTo') }}</label>
            <moment-date-picker v-model="filter.dateOfInvestissementTo" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-1"> 
            <label for="memberSince">{{ $t('dashboard.exit.form.dateOfExitFrom') }}</label>
            <moment-date-picker v-model="filter.dateOfExitFrom" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-1">
            <label for="memberSince">{{ $t('dashboard.exit.form.dateOfExitTo') }}</label>
            <moment-date-picker v-model="filter.dateOfExitTo" :required="false"></moment-date-picker>
          </div-->

          <div class="form-group col-md-2">
              <label for="totalValueInput">{{ $t('dashboard.project.form.totalValueFrom') }}</label>
              <input v-model="filter.totalValueFrom" name="totalValueFrom" type="number" 
                  class="form-control" id="totalValueFrom" />
          </div>

          <div class="form-group col-md-2">
              <label for="totalValueInput">{{ $t('dashboard.project.form.totalValueTo') }}</label>
              <input v-model="filter.totalValueTo" name="totalValueTo" type="number" 
                  class="form-control" id="totalValueTo" />
          </div>

          <div class="form-group col-md-2">
              <label for="totalValueInput">{{ $t('dashboard.exit.form.totalValueExitFrom') }}</label>
              <input v-model="filter.totalValueExitFrom" name="totalValueExitFrom" type="number" 
                  class="form-control" id="totalValueExitFrom" />
          </div>

          <div class="form-group col-md-2">
              <label for="totalValueInput">{{ $t('dashboard.exit.form.totalValueExitTo') }}</label>
              <input v-model="filter.totalValueExitTo" name="totalValueExitTo" type="number" 
                  class="form-control" id="totalValueExitTo" />
          </div>

        </div>

      </div>
    </div>

    <div class="row" v-if="data.length == 0">
      
      <div class="col-xl-12 col-sm-6 mb-4" >
        <div :class="'card text-white o-hidden bg-secondary h-100'">
          <div class="card-body">
            <div class="card-body-icon">
              <i class="fa fa-spinner"></i>
            </div>
            <div class="mr-5">{{ $t("loading")}}</div>
          </div>
        </div>
      </div>
    
    </div>

    <div v-if="data.length != 0">
      <div class="row" >
        <div class="col-md-3" >

          <div class="row">
            <div class="col-sm-12 mb-3" >
              <div class="card text-white o-hidden bg-danger mb-3">
                
                 <div class="card-body">
                  <div class="card-body-icon">
                    <i class="fa fa-fw fa-sign-out"></i>
                  </div>
                  <div class="mr-5">{{ $t("dashboard.exit.data.title") }}</div>
                </div>
                
                <ul class="list-group list-group-flush text-dark">
                  <li class="list-group-item"> {{ $t("dashboard.exit.data.quantity") }} 
                    <span class="pull-right"><strong>{{ quantity }}</strong></span>
                  </li>
                   <li class="list-group-item"> {{ $t("dashboard.exit.data.total") }} 
                    <span class="pull-right"><strong>$ {{ total }}</strong></span>
                  </li>
                   <li class="list-group-item"> {{ $t("dashboard.exit.data.quantityInvestments") }} 
                    <span class="pull-right"><strong>{{ quantityInvestments }}</strong></span>
                  </li>
                  <li class="list-group-item"> {{ $t("dashboard.exit.data.totalInvestments") }} 
                    <span class="pull-right"><strong>$ {{ totalInvestments }}</strong></span>
                  </li>
                  <li class="list-group-item"> {{ $t("dashboard.exit.data.meanFactor") }} 
                    <span class="pull-right"><strong>{{ meanFactor }} %</strong></span>
                  </li>
                  <li class="list-group-item"> {{ $t("dashboard.exit.data.meanDuration") }} 
                    <span class="pull-right"><strong>{{ meanDuration }}</strong></span>
                  </li>
                </ul>
              </div>

              <div class="row">
                <div class="col-sm-12 mb-3" >
                  <div class="card text-white o-hidden bg-danger">
                    <div class="card-body">
                      <div class="card-body-icon">
                        <i class="fa fa-fw fa-dollar"></i>
                      </div>
                      <div class="mr-5">{{ meanTri }} {{ $t('dashboard.exit.data.meanTri') }}</div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>

        </div>

        <div class="col-md-9" >

          <div class="row">
            
            <div class="col-md-6">
              <div class="card mb-3" v-if="sectorData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.exit.sectorVisualisation") }} </div>
                  <pie-chart :chart-data="sectorData.data" :options="sectorData.options"></pie-chart>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card mb-3" v-if="regionData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.exit.regionVisualisation") }} </div>
                  <pie-chart :chart-data="regionData.data" :options="regionData.options"></pie-chart>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card mb-3" v-if="reasonData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.exit.reasonVisualisation") }} </div>
                  <pie-chart :chart-data="reasonData.data" :options="reasonData.options"></pie-chart>
              </div>
            </div>

          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import {
  CompanyServiceClient,
  ProjectServiceClient,
  InvestmentServiceClient,
  AddressServiceClient,
  RoleServiceClient,
  ExitServiceClient,
} from '../../shared/service-clients/service-clients'

import DashboardMixin from '../../shared/Mixin/DashboardMixin'

export default {
  name: 'ExitDashboard',
  mixins: [DashboardMixin],
  data() {
    return {
      data: [],
      regions: [],
      sectors: [],
      companyStatuses: [],
      reasons: [],
      filter: {
        region: [],
        sector: [],
        companyStatus: [],
        reasons: [],
        dateOfInvestissementFrom: null,
        dateOfInvestissementTo: null,
        dateOfExitFrom: null,
        dateOfExitTo: null,
        totalValueFrom: null,
        totalValueTo: null,
        totalValueExitFrom: null,
        totalValueExitTo: null,
      },
    }
  },
  computed: {
    filteredData: function() {
      let filtered = this.data

      filtered = this.filterPropertyByList(filtered, this.filter.region, 'region')
      filtered = this.filterPropertyByList(filtered, this.filter.sector, 'sectorOfActivity')
      filtered = this.filterPropertyByList(filtered, this.filter.companyStatus, 'companyStatus')
      filtered = this.filterSubPropertyByList(filtered, this.filter.reason, 'exits', 'reason')

      filtered = this.filterPropertyByGreaterFloat(filtered, this.filter.totalValueTo, 'totalExit')
      filtered = this.filterPropertyByLesserFloat(filtered, this.filter.totalValueFrom, 'totalExit')

      filtered = this.filterPropertyByGreaterFloat(filtered, this.filter.totalValueExitTo, 'totalInvestment')
      filtered = this.filterPropertyByLesserFloat(filtered, this.filter.totalValueExitFrom, 'totalInvestment')

      return filtered
    },
    filteredExitData: function() {
      let data = _.chain(this.filteredData)
        .flatMap(f => f.exits)
        .map(m => ({data: m.date, value: m.value, reason: m.reason, reasonText: m.exitReasonText}))
        .value()

      data = this.filterPropertyByList(data, this.filter.reason, 'reason')

      return data
    },
    filteredInvestmentData: function() {
      let filtered = this.filteredData

      return _.chain(filtered)
        .flatMap(f => f.investments)
        .map(m => ({data: m.dateOfInvestment, value: m.totalValue}))
        .value()
    },
    quantity: function() {
      return this.filteredData.length
    },
    total: function() {
      return _.sumBy(this.filteredData, 'totalExit').toFixed(0)
    },
    quantityInvestments: function() {
      return this.filteredData.length
    },
    totalInvestments: function() {
      return _.sumBy(this.filteredData, 'totalInvestment').toFixed(0)
    },
    meanFactor: function() {
      return (this.total / this.totalInvestments).toFixed(2)
    },
    meanDuration: function() {
      return _.meanBy(this.filteredData, 'duration')
    },
    meanTri: function() {
      return _.meanBy(this.filteredData, 'tri')
    },
    sectorData: function() {
      return this.getChartMeanData('sectorOfActivityText', 'totalExit', this.filteredData)
    },
    regionData: function() {
      return this.getChartMeanData('regionText', 'totalExit', this.filteredData)
    },
    reasonData: function() {
      return this.getChartSumData('reasonText', 'value', true, this.filteredExitData)
    },
  },
  methods: {
    fetchData: function() {
      let self = this
      // Workaround for the first time hit bug
      // TODO : Essayer de comprends qqs se passe...
      let pingService = ServiceFactory.create(RoleServiceClient)
      pingService.getAll(0, 1).then(rest => {
        let projectService = ServiceFactory.create(ProjectServiceClient)
        let companyService = ServiceFactory.create(CompanyServiceClient)
        let exitService = ServiceFactory.create(ExitServiceClient)
        let addressService = ServiceFactory.create(AddressServiceClient)

        self.getDashboardData(exitService)
        self.getFilterData(projectService, companyService, exitService, addressService)
      })
    },
    getFilterData: function(projectService, companyService, exitService, addressService) {
      let self = this

      projectService.getCompanyStatus().then(res => {
        self.companyStatuses = res
      })
      companyService.getSectorOfActivity().then(res => {
        self.sectors = res
      })
      addressService.getRegions().then(res => {
        self.regions = res
      })
      exitService.getReasons().then(res => {
        self.reasons = res
      })
    },
    getDashboardData: function(service) {
      let self = this
      service
        .getDashboardData()
        .then(res => {
          self.data = res
          this.filterVisible = true
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Exit.vue